import axios from "axios";
import { NewTask, TaskItemNote } from "../types";

export const getNotes = async (task: NewTask) => {
  if (task?.id) {
    let { data } = await axios.get(`/api/taskmanagement/newtasks/getnotes?taskId=${task?.id}`);
    data = data.sort(
      (a: TaskItemNote, b: TaskItemNote) =>
        new Date(b.dateCreated || "").getTime() - new Date(a.dateCreated || "").getTime()
    );
    return data;
  }
};
